import storage, { removeToken } from "@/utils/auth";
import { user } from "@/api/carOwner_zhengxing/receive.js";
import router from "@/router";

const getDefaultState = () => ({
  token: storage.token || "",
  carPhone_number: storage.carPhone_number || "",
  user_info: {
    phone_number: "",
    available_vip: [],
    exchanged_items: [],
  },
});

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN(state, status) {
    state.token = status;
    storage.token = state.token;
  },
  SET_PHONE_NUMBER(state, status) {
    state.carPhone_number = status;
    storage.carPhone_number = state.carPhone_number;
    console.log(state)
  },
  SET_USER_INFO(state, status) {
    state.user_info = status;
  },
};

const actions = {
  async getUserInfo({ state, commit }) {
    try {
      const res = await user(state.token);
      if (res.code == 0 ) {
        commit("SET_USER_INFO", res.user_info);
      }
    } catch (error) {
      router.replace("/carOwner_zhengxing/receive/login");
    }
  },
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
};
